import Layout from 'components/Layout';
import { SEO } from 'components/SEO';
import PrivacyPolicyContainer from 'containers/PrivacyPolicyContainer';
import { graphql } from 'gatsby';
import React, { useEffect } from 'react';
import { track } from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { MEMBERSHIP_INTAKE } from 'utils/constants/dataTest';
import { PageSectionType } from 'utils/types';

type Props = {
  data: {
    content: {
      sections: PageSectionType[];
      title: string;
    };
    allSpreeProduct: any;
  };
  location: any;
};

const PrivacyPolicyPage = ({ data }: Props): React.ReactElement | null => {
  useEffect(() => {
    track({
      event: ANALYTICS.EVENTS.VIEWED_PAGE,
      data: {
        label: ANALYTICS.LABELS.PRIVACY_POLICY,
      },
    });
  }, []);

  return (
    <div data-testid={MEMBERSHIP_INTAKE.INDEX.PAGE}>
      <SEO title="Privacy Policy" />
      <Layout>
        <PrivacyPolicyContainer
          title={data.content.title}
          sections={data.content.sections}
        />
      </Layout>
    </div>
  );
};

export default PrivacyPolicyPage;

export const data = graphql`
  query {
    content: contentfulPage(pageId: { eq: "Privacy Policy" }) {
      title
      sections {
        sectionId
        featureFlag
        componentName
        componentVariation
        title
        slug
        headline
        subHeadline
        description {
          childMarkdownRemark {
            html
          }
          description
        }
        subHeadlineDescription {
          childMarkdownRemark {
            html
          }
          subHeadlineDescription
        }
        mainCta {
          text
          url
          appearance
        }
        listOfContentWithImages {
          slug
          heading
          subheading
          title
          description {
            childMarkdownRemark {
              html
            }
            description
          }
          image {
            gatsbyImageData(placeholder: BLURRED, width: 414, quality: 100)
            description
          }
          cta {
            text
            url
            appearance
          }
          subheading
          number
          identifier
          featureFlag
        }
        desktopImages {
          gatsbyImageData(placeholder: BLURRED, quality: 100)
          description
        }
        mobileImages {
          gatsbyImageData(placeholder: BLURRED, quality: 100)
          description
        }
        listOfLinks {
          text
          url
        }
        backgroundColor
      }
    }
  }
`;
